import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "as-stats-btn as-btn-target",
  type: "button"
}
const _hoisted_2 = { class: "as-target-home" }
const _hoisted_3 = { class: "as-target-away" }
const _hoisted_4 = {
  class: "as-stats-btn as-btn-corner",
  type: "button"
}
const _hoisted_5 = { class: "as-corner-home" }
const _hoisted_6 = { class: "as-corner-away" }
const _hoisted_7 = {
  class: "as-stats-btn as-btn-yellow-card",
  type: "button"
}
const _hoisted_8 = { class: "as-yellow-card-home" }
const _hoisted_9 = { class: "as-yellow-card-away" }

import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import type { IMatch } from "~src/interfaces";
import IconTarget from "~src/components/icons/IconTarget.vue";
import IconCornerNew from "~src/components/icons/IconCornerNew.vue";
import IconYellowCard from "~src/components/icons/IconYellowCard.vue";

const __default__ = {};

interface IProps {
  match: IMatch;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StatsBtn',
  props: {
    match: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;
const siteName = computed(() => commonStore.getSiteName);

const homeScores = computed(() => {
  return props.match.home_scores || [];
});

const awayScores = computed(() => {
  return props.match.away_scores || [];
});

const target = computed(() => {
  const halfTimeStatistics = props.match.half_time_statistics;
  if(halfTimeStatistics && halfTimeStatistics.ft && halfTimeStatistics.ft[21]) {
    return halfTimeStatistics.ft[21];
  }

  return null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-stats-btn-list", `as-stats-btn-list-${siteName.value}`])
  }, [
    _createElementVNode("button", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(target.value ? target.value[0] : "_"), 1),
      _createVNode(IconTarget),
      _createElementVNode("span", _hoisted_3, _toDisplayString(target.value ? target.value[1] : "_"), 1)
    ]),
    _createElementVNode("button", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(homeScores.value.length > 0 ? homeScores.value[4] : "_"), 1),
      _createVNode(IconCornerNew, {
        fill_top: "#5EB24A",
        fill_bottom: "#FFB400"
      }),
      _createElementVNode("span", _hoisted_6, _toDisplayString(awayScores.value.length > 0 ? awayScores.value[4] : "_"), 1)
    ]),
    _createElementVNode("button", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(homeScores.value.length > 0 ? homeScores.value[3] : "_"), 1),
      _createVNode(IconYellowCard),
      _createElementVNode("span", _hoisted_9, _toDisplayString(awayScores.value.length > 0 ? awayScores.value[3] : "_"), 1)
    ])
  ], 2))
}
}

})